import { baseURL } from "../utilits/config";
import axios from "axios";

export function AddMarketData(Marketdata, callback){
      const config = {
          method : 'post',
          url : baseURL + "/add-marketIntelligency",
          headers : {
              "Content-Type" : "application/json"
          },
          data : Marketdata
      };

        axios(config)
           .then((result) =>{
              callback(result.data);
           })
           .catch((error) =>{
              callback(error);
           })
};

export function getAllMarketData(callback){
    const config = {
        method : 'get',
        url : baseURL + "/add-marketIntelligency",
        headers : {
           
        }
    };

      axios(config)
         .then((result) =>{
            callback(result.data);
         })
         .catch((error) =>{
            callback(error);
         })
}